import EditCrop from '../../containers/home/EditCrop';

export default EditCrop;